<template>
    <div class="w-full" v-html="html">
    </div>
</template>

<style>
</style>

<script>
export default {
    name: 'PluginStyle',
    props: {
        html: {
            required: true
        }
    },
}
</script>